import { useNavigate, useParams } from 'react-router-dom'
import { useEffect } from 'react'

import { useTicketsById } from '@hooks'
import { useUser } from '@contexts'
import { ROUTE_KEYS } from '@constants'
import { RoleEnum } from '@types'

import LoadingSpinner from '../LoadingSpinner'
import TicketDetail from './TicketDetail'

const { ADMIN, ADMINRO } = RoleEnum

const allowedRoles = [ADMIN, ADMINRO]

const TicketView = () => {
  const { id } = useParams<{ id: string }>()
  const { ticketById } = useTicketsById(Number(id))
  const navigate = useNavigate()
  const { state: user } = useUser()

  useEffect(() => {
    if (!(id && user && allowedRoles.includes(user.roles[0].name))) {
      navigate(user ? ROUTE_KEYS[user.roles[0].name].HOME : ROUTE_KEYS.LOGIN.HOME)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return ticketById?.ticket ? <TicketDetail ticket={ticketById.ticket} /> : <LoadingSpinner />
}

export default TicketView
